import { render } from "./classedit.vue?vue&type=template&id=2076d5e3"
import script from "./classedit.vue?vue&type=script&lang=js"
export * from "./classedit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\www\\ctx\\Uis\\mch\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__